import { P3Configuration } from 'models/interfaces/P3Configurations';

const entitlementValidation = (value: string) => {
  if (typeof value === 'undefined' || value === null) {
    return 'Required';
  }
  const parsedValue = parseInt(value, 10);

  if (isNaN(parsedValue)) {
    return 'Value must be a number';
  }

  return null;
};

const nameValidation = (value: string) => {
  if (!value) {
    return 'Required';
  }
  if (value.match(/\[ENTER NAME\]/g)) {
    return 'Enter a Name';
  }

  return null;
};

const buildTemplateOptions = (p3Configurations: P3Configuration[]) => {
  // console.log('Begin buildTemplateOptions - p3Configurations: ', p3Configurations);
  console.time('makeTemplateOptions');
  const templateOptions: any[] = [];

  const [companyTemplates, userTemplates, campaignConfigurations] = p3Configurations.reduce(
    (acc: [any[], any[], any[]], p3: P3Configuration) => {
      // campaign configurations
      if (p3.p3_campaign_id) {
        acc[2].push({
          value: p3.p3_configuration_id,
          name: p3.name
        });
      } else if (p3.tgrams_id) {
        // company templates
        acc[0].push({
          value: p3.p3_configuration_id,
          name: p3.name
        });
      } else {
        // user templates
        acc[1].push({
          value: p3.p3_configuration_id,
          name: p3.name
        });
      }

      return acc;
    },
    [[], [], []]
  );

  if (companyTemplates.length > 0) {
    templateOptions.push({
      label: 'Company Configurations',
      options: companyTemplates
    });
  }

  if (userTemplates.length > 0) {
    templateOptions.push({
      label: 'User Configurations',
      options: userTemplates
    });
  }

  if (campaignConfigurations.length > 0) {
    templateOptions.push({
      label: 'Campaign Configurations',
      options: campaignConfigurations
    });
  }

  console.timeEnd('makeTemplateOptions');

  return templateOptions;
};

export { nameValidation, entitlementValidation, buildTemplateOptions };
